module.exports = __webpack_public_path__ + "static/media/3.2df43e35.jpg";